
import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import Axios from "axios";
import AkkhorLayout from "../layout/akkhor";
import { URL_LIST_ALL } from "../configs/api";
import { confirmAlert } from "react-confirm-alert";
import Spinner from "../component/Spinner";
import CauHoiRenderer from "./CauHoiRenderer";

export default function ChamBaiLam() {
    const { id } = useParams(); // bailam_id
    const { user } = useSelector((state) => state.auth);
    const [bailam, setBailam] = useState(null);
    const [loading, setLoading] = useState(false);
    const [saving, setSaving] = useState(false);
    const [grades, setGrades] = useState({}); // { chitiet_id: {diem_dat, nhan_xet} }

    const load = () => {
        setLoading(true);
        Axios.get(URL_LIST_ALL + "learninghub_bailam/" + id, user.config)
            .then((res) => {
                setLoading(false);
                if (res.data.status === "success") {
                    const d = res.data.data;
                    setBailam(d);
                    const g = {};
                    (d.list_chitiet || []).forEach((c) => {
                        if (c.cham_tay === 1) g[c.id] = { diem_dat: c.diem_dat || 0, nhan_xet: c.nhan_xet || '' };
                    });
                    setGrades(g);
                } else console.log(res.data.message);
            })
            .catch((err) => { console.log(err); setLoading(false); });
    };

    useEffect(() => { if (id > 0) load(); }, [user, id]);// eslint-disable-line

    const parse = (v) => { try { return typeof v === 'object' ? v : JSON.parse(v); } catch (e) { return v; } };
    const setGrade = (cid, field, val) => setGrades((p) => ({ ...p, [cid]: { ...p[cid], [field]: val } }));
    const fmtDuration = (start, end) => {
        if (!start || !end || end < start) return null;
        const s = end - start, m = Math.floor(s / 60), ss = s % 60;
        return (m > 0 ? m + ' phút ' : '') + ss + ' giây';
    };

    const submit = () => {
        const payload = {
            bailam_id: Number(id),
            grades: Object.keys(grades).map((cid) => ({
                chitiet_id: Number(cid),
                diem_dat: Number(grades[cid].diem_dat) || 0,
                nhan_xet: grades[cid].nhan_xet || '',
            })),
        };
        setSaving(true);
        Axios.post(URL_LIST_ALL + "learninghub_cham_bailam", payload, user.config)
            .then((res) => {
                setSaving(false);
                if (res.data.status === "success") {
                    confirmAlert({ title: 'Thành công', message: 'Đã chấm xong. Tổng điểm: ' + res.data.tong_diem, buttons: [{ label: 'OK', onClick: load }] });
                } else confirmAlert({ title: 'Lỗi', message: res.data.message, buttons: [{ label: 'OK' }] });
            })
            .catch((err) => { console.log(err); setSaving(false); });
    };

    const hasEssay = bailam && (bailam.list_chitiet || []).some((c) => c.cham_tay === 1);

    return (
        <AkkhorLayout idrole="learninghub_bailam">
            <div className="breadcrumbs-area">
                <ul>
                    <li><Link to="/">Trang chủ</Link></li>
                    <li><Link to="/learninghub_bailam">Bài làm</Link></li>
                    <li>Chấm bài</li>
                </ul>
            </div>
            {loading && <div className="w-100 text-center"><Spinner /></div>}
            {bailam &&
                <div className="card height-auto mt-2">
                    <div className="card-body">
                        <h3>{bailam.dethi_title}</h3>
                        <div className="mb-3">
                            <span className="mr-3">Thí sinh: <strong>{bailam.hocsinh_name}</strong></span>
                            {fmtDuration(bailam.time_start, bailam.time_submit) && <span className="mr-3"><span className="far fa-clock"></span> Làm trong: {fmtDuration(bailam.time_start, bailam.time_submit)}</span>}
                            <span className="mr-3">Điểm khách quan: {bailam.diem_tu_dong}</span>
                            <span className="mr-3">Điểm tự luận: {bailam.diem_tu_luan}</span>
                            <span>Tổng: <strong>{bailam.tong_diem != null ? bailam.tong_diem : '(chưa chốt)'} / {bailam.dethi_tong_diem}</strong></span>
                        </div>

                        {(bailam.list_chitiet || []).map((c, idx) => {
                            const traloi = parse(c.tra_loi);
                            const isEssay = c.cham_tay === 1;
                            return (
                                <div className="border rounded p-3 mb-3" key={c.id}>
                                    <div className="d-flex justify-content-between">
                                        <strong>Câu {idx + 1} {isEssay && <span className="badge badge-warning">Tự luận</span>}</strong>
                                        <span>
                                            {!isEssay && (c.dung === 1
                                                ? <span className="badge badge-success">Đúng</span>
                                                : <span className="badge badge-danger">Sai</span>)}
                                            <span className="badge badge-dark ml-1">Tối đa {c.diem_cau} điểm</span>
                                        </span>
                                    </div>
                                    <div className="mt-1 mb-2" dangerouslySetInnerHTML={{ __html: c.cauhoi_title }} />

                                    {isEssay
                                        ? <>
                                            <div className="bg-light p-2 rounded mb-2"><em>Bài làm của thí sinh:</em><br />{traloi || <span className="text-muted">(không trả lời)</span>}</div>
                                            <div className="row">
                                                <div className="col-12 col-sm-3 form-group">
                                                    <label>Điểm (tối đa {c.diem_cau})</label>
                                                    <input type="number" step="0.1" min="0" max={c.diem_cau} className="form-control height32"
                                                        value={grades[c.id] ? grades[c.id].diem_dat : 0}
                                                        onChange={(e) => setGrade(c.id, 'diem_dat', e.target.value)} />
                                                </div>
                                                <div className="col-12 col-sm-9 form-group">
                                                    <label>Nhận xét</label>
                                                    <input type="text" className="form-control height32" placeholder="Nhận xét cho câu này"
                                                        value={grades[c.id] ? grades[c.id].nhan_xet : ''}
                                                        onChange={(e) => setGrade(c.id, 'nhan_xet', e.target.value)} />
                                                </div>
                                            </div>
                                        </>
                                        : <CauHoiRenderer cauhoi={c} value={traloi} readOnly={true} correct={c.dapan} />}
                                </div>
                            );
                        })}

                        {hasEssay &&
                            <div className="w-100 text-center mt-4">
                                <button type="button" className="btn-fill-lg btn-gradient-yellow btn-hover-bluedark" disabled={saving} onClick={submit}>
                                    {saving ? <Spinner /> : <>Lưu điểm & chốt bài</>}
                                </button>
                            </div>
                        }
                    </div>
                </div>
            }
        </AkkhorLayout>
    );
}
